import { jsx as _jsx } from "react/jsx-runtime";
import { capitaliseFirstLetter, indefiniteArticle } from "../../utils";
import { CtaButton } from "../cta-button";
export var SearchButton = function(param) {
    var make = param.make, model = param.model, small = param.small, className = param.className, onClick = param.onClick;
    var makeCapitalize = capitaliseFirstLetter(make);
    var modelCapitalize = capitaliseFirstLetter(model);
    var indefiniteArticleValue = indefiniteArticle(make);
    var formattedMake = make.toLowerCase().replace(/ /g, "-");
    var formattedModel = model.toLowerCase().replace(/ /g, "-");
    var searchButton = "Search for ".concat(indefiniteArticleValue, " ").concat(makeCapitalize, " ").concat(modelCapitalize);
    return /*#__PURE__*/ _jsx(CtaButton, {
        href: "/used-cars/".concat(formattedMake, "/").concat(formattedModel),
        onClick: onClick,
        className: className,
        small: small,
        children: searchButton
    });
};
